import React, { useState, useCallback, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import HeartIcon from "../../styles/default/assets/icons/heart.svg";
import EmptyHeartIcon from "../../styles/default/assets/icons/heart-empty.svg";
import { titleCase } from "../../utils/title-case";

const DrugPriceListItem = ({
  drugPrice,
  active,
  selected,
  onMouseEnter,
  onMouseLeave,
  onClick,
  components: { Icon },
  addToFavorite,
  favoriteList
}) => {
  const { Name, Price, PharmacyName, Distance, Street1, City, State, ZipCode } =
    drugPrice;

  const [isFavorite, setIsFavorite] = useState(
    (favoriteList || []).some(i => i.PharmacyId === drugPrice.PharmacyId)
  );
  const handleFavorite = useCallback(
    event => {
      event.stopPropagation();
      const index = favoriteList.findIndex(
        item => item.PharmacyId === drugPrice.PharmacyId
      );
      if (index === -1) {
        addToFavorite({ favorite: true, meta: drugPrice });
        favoriteList.push(drugPrice);
        setIsFavorite(true);
      } else {
        addToFavorite({ favorite: false, meta: drugPrice });
        favoriteList.splice(index, 1);
        setIsFavorite(false);
      }
    },
    [drugPrice]
  );

  const el = useRef();

  useEffect(() => {
    if (selected && el.current) {
      el.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [selected]);

  return (
    <div
      role='button'
      tabIndex={0}
      ref={el}
      onKeyDown={() => onClick(drugPrice)}
      className={`price-prescriptions-list-item ${
        active || selected ? "active" : ""
      }`}
      onMouseEnter={() => onMouseEnter(drugPrice)}
      onMouseLeave={() => onMouseLeave(drugPrice)}
      onClick={() => onClick(drugPrice)}
    >
      <div className='websdk-flex websdk-justify-between'>
        <div className='websdk-font-bold websdk-text-blue'>
          {titleCase(Name)}
        </div>
        <div>{`$${Price.toFixed(2)}`}</div>
      </div>
      <div className='websdk-flex websdk-justify-between'>
        <div>{titleCase(PharmacyName)}</div>
        <div className='text-pale-grey-200'>{`${Distance.toFixed(2)} mi`}</div>
      </div>
      <div className='websdk-flex websdk-items-start websdk-justify-between'>
        <div className='websdk-flex websdk-flex-col'>
          <p>{`${titleCase(Street1)}`}</p>
          <p>{`${titleCase(City)}, ${State} ${ZipCode}`}</p>
        </div>

        <div className='price-prescriptions-list-item-heart'>
          {!!(addToFavorite && favoriteList) && (
            <Icon
              showIcon
              src={isFavorite ? HeartIcon : EmptyHeartIcon}
              onClick={handleFavorite}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DrugPriceListItem;

DrugPriceListItem.propTypes = {
  active: PropTypes.bool,
  selected: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  components: PropTypes.object,
  addToFavorite: PropTypes.func,
  favoriteList: PropTypes.arrayOf(PropTypes.string),
  drugPrice: PropTypes.any
};
